import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SavedFilterList } from '../../../state/filter-state/actions';
import { FilterState } from '../../../state/filter-state/filter.state';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FilterUtilService {
  
  constructor(private store: Store) {
  }
  
  applySelectedFilter(scope, getterFn, loader?) {
    scope.filter.currentSelectedFilter.pipe(takeUntil(scope.destroyed$)).subscribe(
      (data) => {
          if (Object.keys(data).length > 0) {
            scope[loader] = true
            scope.filterParamsUrl = data;
            scope.filterDataInit = data;
          } else {
            scope.filterParamsUrl = {};
            scope.filterDataInit = {};
          }
        scope.config.currentPage = scope.page || 1;
        scope.config.itemsPerPage = scope.page_size || 20;
        scope[getterFn.name]();
      },
      (error) => {
        try {
          console.log(error)
        } catch {}
      }
    );
  }

  getSavedFilters(scope, filerPage) {
    let params = {
      filter_page: filerPage,
    };
    this.store.dispatch(new SavedFilterList(params)).subscribe(() => {
      scope.savedFilters = this.store.selectSnapshot(FilterState.getSavedFilters);
    });
  }

  clearfilterParams(params) {
    for (const key in params) {
      delete params[key];
    }
  }
}
